import React, { useContext } from "react";
import {
  PROP_TYPE_PROGRAM_COURSE,
  PROP_DEFAULT_PROGRAM_COURSE,
} from "../../../../propTypes";
import LangContext from "../../../../langContext";
import Description from "../../../Description";
import {
  formatCourseDuration,
  GetRequestedCourseLink,
} from "../../../../functions";
import Rating from "lib/components/Rating";
import { Box } from "Components/Base/Layout/Box";

const ProgramTypeProgram = (props) => {
  const languageContext = useContext(LangContext);
  const { course, activityId, isPreview, isPortalOverview } = props;
  const displayTime = formatCourseDuration(course);
  const displayDescription =
    course.itemDescription && course.itemDescription !== "";

  return (
    <div>
      <Rating
        currentRating={course.avgRating}
        noOfRatings={course.noOfRatings}
        readOnly={true}
      />
      <div>
        <p className="elipssis">
          {`${languageContext("reason")}: `}
          <br />
          <span title={course.reason}>{course.reason}</span>
        </p>
      </div>
      <Box display="flex" justifyContent="center" width="100%">
        {displayTime && (
          <span>
            <span className="icon-time" aria-hidden="true" />
            &nbsp;{displayTime}
          </span>
        )}
        {((course.isActiveStep && !isPreview) || isPortalOverview) && (
          <GetRequestedCourseLink
            courseId={course.courseObjectId}
            activityId={activityId}
            label={languageContext("showprogram")}
            isPortalOverview={isPortalOverview}
          />
        )}
      </Box>
    </div>
  );
};

ProgramTypeProgram.propTypes = {
  course: PROP_TYPE_PROGRAM_COURSE,
};

ProgramTypeProgram.defaultProps = {
  course: PROP_DEFAULT_PROGRAM_COURSE,
};

export default ProgramTypeProgram;
